module.exports = __webpack_public_path__ + "static/media/stars-1366.b1b20774.jpg";